export const LOADING = 'LOADING';
export const SYNC_ACTION_IN_PROGRESS = 'SYNC_ACTION_IN_PROGRESS';
export const REMOVE_FAV_ERROR = 'REMOVE_FAV_ERROR';
export const SHOW_PROPERTY = 'SHOW_PROPERTY';
export const CURRENT_SCROLL = 'CURRENT_SCROLL';
export const LOG_OUT = 'LOG_OUT';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR';
export const FETCH_PROPERTIES = 'FETCH_PROPERTIES';
export const FETCH_PROPERTIES_ERROR = 'FETCH_PROPERTIES_ERROR';
export const ADD_FAVOURITE = 'ADD_FAVOURITE';
export const ADD_FAVOURITE_ERROR = 'ADD_FAVOURITE_ERROR';
export const FETCH_FAVOURITES = 'FETCH_FAVOURITES';
export const FETCH_FAVORITES_ERROR = 'FETCH_FAVORITES_ERROR';
